import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { getRequest } from 'src/utils/request';

import type { RequestData } from 'src/types/requestData';

const mapTutorial = (tutorial: UCM.TutorialRawType, tutorialId: string) => ({
  id: tutorialId,
  code: tutorial.code,
  uuid: tutorial.uuid,
  kind: tutorial.kind,
  cohort: tutorial.cohort,
  title: {
    de: tutorial.title_de,
    en: tutorial.title_en,
  },
  description: {
    de: tutorial.description_de,
    en: tutorial.description_en,
  },
});

const getTutorial = async (tutorialUuid: string) => {
  const {
    data: { data },
  } = await getRequest<RequestData<UCM.TutorialRawType>>(
    API.GET.tutorial(tutorialUuid),
  );

  return mapTutorial(data.attributes, data.id);
};

export const useGetTutorial = (
  uuid: string,
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.TUTORIAL, uuid],
    queryFn: () => getTutorial(uuid),
    staleTime: 1000 * 60 * 5, // Dashboards refreshed after every 5 minutes automatically
    ...config,
  });
};
